import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { Context } from './Context';
const ComboboxError = forwardRef(({ as: Element = 'p', children, render, className, ...rest }, ref) => {
    const { id, isInvalid } = useContext(Context);
    return (_jsx(Element, { ref: ref, id: `${id}-error`, role: "alert", className: className, ...rest, children: render ? render({ isInvalid }) : children }));
});
ComboboxError.displayName = 'Error';
export { ComboboxError };
//# sourceMappingURL=Error.js.map